import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import classes from './attribution-control.module.css';

/**
 * @returns {React.JSX.Element}
 */
export function AttributionControl() {
  return (
    <MapControl position={ControlPosition.RIGHT_BOTTOM}>
      <div className={classes.attributionControl}>
        <a href="http://openstreetmap.org/copyright" target="_blank">
          Route data based on OpenStreetMap
        </a>
      </div>
    </MapControl>
  );
}
